// components/FadeItem.jsx
import React from "react";
import { Typography } from "@mui/material";
import { useFadeInOnScroll } from "../theme/global";

const FadeItem = ({ text, style, variant = "body1" }) => {
  const ref = useFadeInOnScroll();

  return (
    <Typography
      ref={ref}
      className="fade-up"
      variant={variant}
      sx={style}
    >
      {text}
    </Typography>
  );
};

export default FadeItem;
